<script lang="ts">
	import { getDeviceState, type DeviceStateConfig } from 'src/stores/device-runtime/states';

	export let deviceId: string | undefined;

	$: deviceStateStore = getDeviceState(deviceId);
	$: deviceState = $deviceStateStore as DeviceStateConfig | Record<string, never>;
	$: hasDeviceState = Object.keys(deviceState).length > 0;
</script>

<slot {deviceState} {hasDeviceState} />
